<template>
  <div>
    <h1 class="title">
      <span>Prodotti</span>
    </h1>

    <div class="section has-text-left buttons">
      <router-link
        :to="`/user/${$route.params.id}/product/`"
        class="button is-success"
      >
        <b-icon icon="plus-square" size="is-small"></b-icon>
        <span>Aggiungi</span>
      </router-link>

      <button
        class="button is-info"
        v-on:click="onSaveOrder"
        :disabled="$ajax.anyLoading"
      >
        <b-icon icon="save" size="is-small"></b-icon>
        <span>Salva ordinamento</span>
      </button>
    </div>

    <div class="section has-text-left">
      Puoi trascinare le righe per modificare l'ordinamento
    </div>
    <b-table
      :data="products"
      :paginated="isPaginated"
      :per-page="perPage"
      :current-page.sync="currentPage"
      :pagination-simple="isPaginationSimple"
      :default-sort-direction="defaultSortDirection"
      :loading="$ajax.anyLoading"
      striped
      default-sort="id"
      v-sortable="sortableOptions"
      custom-row-key="id"
      class="has-text-left"
    >
      <template>
        <b-table-column field="order" label="Order" v-slot="prop" numeric>{{
          prop.row.customOrder
        }}</b-table-column>

        <b-table-column field="name" label="Nome prodotto" v-slot="prop">
          <router-link
            :to="`/user/${prop.row.clientId}/product/${prop.row.id}`"
          >
            <i class="fas fa-edit"></i>
            {{ prop.row.name | truncate(30) }}
          </router-link>
        </b-table-column>
        <b-table-column field="tipology" label="Tipologia" v-slot="prop">{{
          $ajax.getObject("servicesTipology", prop.row.tipologyId).name
        }}</b-table-column>
        <b-table-column field="category" label="Categoria" v-slot="prop">{{
          prop.row.category
        }}</b-table-column>
        <b-table-column field="pieces" label="Unità" v-slot="prop" numeric>{{
          prop.row.pieces
        }}</b-table-column>
        <b-table-column
          field="quantity"
          label="Quantità"
          v-slot="prop"
          numeric
          >{{ prop.row.quantity }}</b-table-column
        >
        <b-table-column field="total" label="Totale" v-slot="prop" numeric
          >{{ prop.row.total }}
          {{
            $ajax.getObject("productsUm", prop.row.umId).name
          }}</b-table-column
        >

        <b-table-column width="60" class="has-text-right" v-slot="prop">
          <button
            class="button is-small is-danger"
            v-on:click.prevent="onDelete(prop.row)"
          >
            <b-icon icon="trash" size="is-small"></b-icon>
          </button>
        </b-table-column>
      </template>

      <template slot="empty">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>
              <b-icon icon="cookie-bite" size="is-large"></b-icon>
            </p>
            <p>Lista prodotti vuota</p>
          </div>
        </section>
      </template>
    </b-table>
  </div>
</template>


<script>
import Sortable from "sortablejs";
const createSortable = (el, options, vnode) => {
  return Sortable.create(el, {
    ...options,
    onEnd: function (evt) {
      const data = vnode.context.products;
      const item = data[evt.oldIndex];
      if (evt.newIndex > evt.oldIndex) {
        for (let i = evt.oldIndex; i < evt.newIndex; i++) {
          data[i] = data[i + 1];
        }
      } else {
        for (let i = evt.oldIndex; i > evt.newIndex; i--) {
          data[i] = data[i - 1];
        }
      }

      data[evt.newIndex] = item;
      data.forEach((element, index) => {
        element.customOrder = index;
      });

      item.customOrder = evt.newIndex;
      /*
      vnode.context.$toast.open(
        `Moved ${item.name} from row ${evt.oldIndex + 1} to ${evt.newIndex + 1}`
      );
      */
    },
  });
};

/**
 * We add a new instance of Sortable when the element
 * is bound or updated, and destroy it when it's unbound.
 */
const sortable = {
  name: "sortable",
  bind(el, binding, vnode) {
    const table = el.querySelector("table");
    table._sortable = createSortable(
      table.querySelector("tbody"),
      binding.value,
      vnode
    );
  },
  update(el, binding, vnode) {
    const table = el.querySelector("table");
    table._sortable.destroy();
    table._sortable = createSortable(
      table.querySelector("tbody"),
      binding.value,
      vnode
    );
  },
  unbind(el) {
    const table = el.querySelector("table");
    table._sortable.destroy();
  },
};

export default {
  name: "products",
  directives: { sortable },

  data() {
    return {
      products: [],
      // table
      isPaginated: false,
      isPaginationSimple: false,
      defaultSortDirection: "asc",
      currentPage: 1,
      perPage: 30,
      sortableOptions: {
        chosenClass: "is-selected",
      },
    };
  },
  methods: {
    onDelete(row) {
      const vm = this;
      this.$buefy.dialog.confirm({
        title: "Cancella prodotto",
        message: `Sei sicuro di voler <b>eliminare</b> il prodotto <i>${row.name}</i>? Verrà rimosso da tutte le schede e le statistiche. <b>Questa azione è irreversibile</b>.`,
        confirmText: "Elimina",
        cancelText: "Annulla",
        type: "is-danger",
        scroll: "keep",
        hasIcon: true,
        onConfirm: () => {
          this.$ajax.request({
            address: "/products/" + row.id,
            method: "DELETE",
            onSuccess: () => {
              vm.products.splice(vm.products.indexOf(row), 1);
            },
          });
        },
      });
    },
    onSaveOrder() {
      var array = [];
      this.products.forEach((element) => array.push(element.id));

      this.$ajax.request({
        address: "/products/custom-order",
        method: "PUT",
        data: {
          userId: this.$route.params.id,
          order: array,
        },
        onSuccess: () => {},
      });
    },
  },
  mounted() {
    if (this.$route.params.id) {
      const vm = this;
      this.$ajax.request({
        address: "/products/search/",
        method: "POST",
        data: {
          customerId: this.$route.params.id,
          orderBy: "CustomOrder",
          limit: 512,
        },
        onSuccess: (response) => {
          response.data.forEach((item) => vm.products.push(item));
        },
      });
    }
  },
};
</script>
